<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <p>{{test1}}</p>
    <HelloWorld ref="hello" msg="Welcome to Your Vue.js App" >{{test2}}</HelloWorld>
    <StockQuotes title="My stocks" />
    <!-- <SessionTime /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import StockQuotes from '@/components/StockQuotes/StockQuotes.vue'
// import SessionTime from '@/components/SessionTime.vue'

export default {
  name: 'home',
  components: {
    HelloWorld,
    StockQuotes
    // SessionTime,
  },
  data: function() {
    return {
      test1: 'This is test1',
      test2: 'This is test2'
    }
  }
}
</script>
